export enum EventListStatus {
  live = 'live',
  upcoming = 'upcoming',
  past = 'past',
  unfinished = 'unfinished',
  all = 'all',
}
